import { getTemplate } from "../template-helper";
import { uuidv4 } from "../../util/utils";

const COMPONENT_NAME = "z-uuid" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class UUIDComponent extends HTMLElement {
            constructor() {
                super();
                this.isFirstInit = true;
            }

            init() {
                if(this.innerHTML) { return; }
                this.appendChild(template.content.cloneNode(true));        
        
                this.currentValue = uuidv4();
                this.renderWidget();

                setTimeout(()=>{
                    this.dispatchEvent(new Event('change', {bubbles: true}));
                }, 100)
            }

            renderWidget() {
                this.spanElement = this.querySelector("span");
                this.spanElement.innerText = this.currentValue;
            }

            connectedCallback(){
                this.init();
            }

            set value(value){
                if(this.isFirstInit){
                    this.currentValue = value? value : (this.currentValue || uuidv4());
                    this.isFirstInit = false;
                    this.renderWidget();
                }
            }

            get value() {
                return this.currentValue;
            }
        }
        customElements.define(COMPONENT_NAME, UUIDComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}
